import { get } from 'lodash';
import cookies from 'js-cookie';
import moment from 'moment/moment';
import { initAppContext } from 'Context/initAppContext';
import { setLocale as setI18nLocale } from 'Src/i18n';
import { getDeviceByUA } from 'Components/utils/responsive/Responsive.helper';
// Server-side the context is created everytime
// client-side, it's first saved in the constructor of _app, then retrieved in subsequent
// getInitialProps
let localAppContext;

const loadMomentLocale = async (locale = 'en') => {
  if (locale !== 'en') {
    try {
      await import(`moment/locale/${locale}`);
    } catch {
      locale = 'en';
    }
  }

  moment.locale(locale);
};

export const getAppContext = (): AppContext => localAppContext;
export const saveAppContext = (appContext: AppContext) => {
  const userAgent = get(window, 'navigator.userAgent');
  const data: AppContext = {
    ...appContext,
    cookies: cookies.get(),
    userAgent,
    device: appContext.device ?? getDeviceByUA(userAgent),
  };
  localAppContext = { ...data, ...initAppContext(data.originalUrl, data) };
  const momentLocale = get(
    localAppContext,
    `availableLocales.${localAppContext.locale}.moment`,
    'fr',
  );
  loadMomentLocale(momentLocale);
  setI18nLocale(localAppContext.locale.slice(0, 2));
  return localAppContext;
};
